<app-catalog-page-card title="INVESTORS">
  <app-catalog-table-toolbar
    datatableId="kt_investor_datatable"
    searchPlaceholder="Search investor records..."
    addButtonLabel="Add Investor"
    addModalId="create_investor_modal"
    refreshAriaLabel="Refresh investors"
    [disableRefresh]="isLoading()"
    (refresh)="loadInvestors()"
  ></app-catalog-table-toolbar>

  <app-catalog-crud-modal
    modalId="create_investor_modal"
    title="Create Investor"
    submitLabel="Create Investor"
    [submitting]="isCreating()"
    [formError]="createFormError()"
    (submit)="onCreateInvestor()"
    (cancel)="resetCreateInvestorForm()"
  >
    <div modal-body>
      <form class="grid gap-4" autocomplete="off" [formGroup]="createInvestorForm">
                @if (lookupError()) {
                  <div class="kt-alert kt-alert-destructive" role="alert">
                    <div class="kt-alert-text">{{ lookupError() }}</div>
                  </div>
                }

                <div class="grid gap-1.5">
                  <label class="kt-form-label" for="create-investor-name">
                    Name <span class="catalog-required-marker" aria-hidden="true">*</span>
                  </label>
                  <input
                    id="create-investor-name"
                    type="text"
                    class="kt-input"
                    formControlName="name"
                    [attr.aria-invalid]="shouldShowCreateFieldError('name')"
                  />

                  @if (shouldShowCreateFieldError('name')) {
                    <div class="catalog-field-error">Name is required.</div>
                  }
                </div>

                <div class="grid gap-1.5">
                  <label class="kt-form-label" for="create-investor-type">
                    Investor Type <span class="catalog-required-marker" aria-hidden="true">*</span>
                  </label>
                  <select
                    id="create-investor-type"
                    class="kt-select"
                    formControlName="investorTypeId"
                    [attr.aria-invalid]="shouldShowCreateFieldError('investorTypeId')"
                  >
                    <option value="">Select investor type...</option>
                    @for (item of investorTypes(); track item.id) {
                      <option [value]="item.id">{{ item.name }}</option>
                    }
                  </select>

                  @if (shouldShowCreateFieldError('investorTypeId')) {
                    <div class="catalog-field-error">Investor Type is required.</div>
                  }
                </div>

                <div class="grid gap-1.5">
                  <label class="kt-form-label" for="create-investor-country">
                    Country <span class="catalog-required-marker" aria-hidden="true">*</span>
                  </label>
                  <select
                    id="create-investor-country"
                    class="kt-select"
                    data-kt-select="true"
                    data-kt-select-enable-search="true"
                    data-kt-select-search-placeholder="Search..."
                    data-kt-select-placeholder="Select a country..."
                    data-kt-select-config='{"optionsClass":"kt-scrollable overflow-auto max-h-[250px]"}'
                    formControlName="countryId"
                    [attr.aria-invalid]="shouldShowCreateFieldError('countryId')"
                  >
                    <option value="">Select a country...</option>
                    @for (item of countries(); track item.id) {
                      <option [value]="item.id">{{ item.name }}</option>
                    }
                  </select>

                  @if (shouldShowCreateFieldError('countryId')) {
                    <div class="catalog-field-error">Country is required.</div>
                  }
                </div>

                <div class="grid gap-1.5">
                  <label class="kt-form-label" for="create-investor-region">
                    Region <span class="catalog-required-marker" aria-hidden="true">*</span>
                  </label>
                  <select
                    id="create-investor-region"
                    class="kt-select"
                    formControlName="regionId"
                    [attr.aria-invalid]="shouldShowCreateFieldError('regionId')"
                  >
                    <option value="">Select region...</option>
                    @for (item of regions(); track item.id) {
                      <option [value]="item.id">{{ item.name }}</option>
                    }
                  </select>

                  @if (shouldShowCreateFieldError('regionId')) {
                    <div class="catalog-field-error">Region is required.</div>
                  }
                </div>

                <div class="grid gap-1.5">
                  <label class="kt-form-label" for="create-investor-group">
                    Investor Group <span class="catalog-required-marker" aria-hidden="true">*</span>
                  </label>
                  <select
                    id="create-investor-group"
                    class="kt-select"
                    data-kt-select="true"
                    data-kt-select-enable-search="true"
                    data-kt-select-search-placeholder="Search..."
                    data-kt-select-placeholder="Select an investor group..."
                    data-kt-select-config='{"optionsClass":"kt-scrollable overflow-auto max-h-[250px]"}'
                    formControlName="investorGroupId"
                    [attr.aria-invalid]="shouldShowCreateFieldError('investorGroupId')"
                  >
                    <option value="">Select investor group...</option>
                    @for (item of investorGroups(); track item.id) {
                      <option [value]="item.id">{{ item.name }}</option>
                    }
                  </select>

                  @if (shouldShowCreateFieldError('investorGroupId')) {
                    <div class="catalog-field-error">Investor Group is required.</div>
                  }
                </div>
              </form>
    </div>
  </app-catalog-crud-modal>

  <button
    type="button"
    class="hidden"
    aria-hidden="true"
    tabindex="-1"
    data-kt-modal-toggle="#edit_investor_modal"
  ></button>

  <app-catalog-crud-modal
    modalId="edit_investor_modal"
    title="Edit Investor"
    submitLabel="Save Changes"
    widthClass="max-w-[1100px]"
    [submitting]="isUpdating()"
    [formError]="editFormError()"
    (submit)="onUpdateInvestor()"
    (cancel)="resetEditInvestorForm()"
  >
    <div modal-body>
      <form class="grid gap-4" autocomplete="off" [formGroup]="editInvestorForm">
                @if (lookupError()) {
                  <div class="kt-alert kt-alert-destructive" role="alert">
                    <div class="kt-alert-text">{{ lookupError() }}</div>
                  </div>
                }

                <div class="grid gap-1.5">
                  <label class="kt-form-label" for="edit-investor-name">
                    Name <span class="catalog-required-marker" aria-hidden="true">*</span>
                  </label>
                  <input
                    id="edit-investor-name"
                    type="text"
                    class="kt-input"
                    formControlName="name"
                    [attr.aria-invalid]="shouldShowEditFieldError('name')"
                  />

                  @if (shouldShowEditFieldError('name')) {
                    <div class="catalog-field-error">Name is required.</div>
                  }
                </div>

                <div class="grid gap-1.5">
                  <label class="kt-form-label" for="edit-investor-type">
                    Investor Type <span class="catalog-required-marker" aria-hidden="true">*</span>
                  </label>
                  <select
                    id="edit-investor-type"
                    class="kt-select"
                    formControlName="investorTypeId"
                    [attr.aria-invalid]="shouldShowEditFieldError('investorTypeId')"
                  >
                    <option value="">Select investor type...</option>
                    @for (item of investorTypes(); track item.id) {
                      <option [value]="item.id">{{ item.name }}</option>
                    }
                  </select>

                  @if (shouldShowEditFieldError('investorTypeId')) {
                    <div class="catalog-field-error">Investor Type is required.</div>
                  }
                </div>

                <div class="grid gap-1.5">
                  <label class="kt-form-label" for="edit-investor-country">
                    Country <span class="catalog-required-marker" aria-hidden="true">*</span>
                  </label>
                  <select
                    id="edit-investor-country"
                    class="kt-select"
                    data-kt-select="true"
                    data-kt-select-enable-search="true"
                    data-kt-select-search-placeholder="Search..."
                    data-kt-select-placeholder="Select a country..."
                    data-kt-select-config='{"optionsClass":"kt-scrollable overflow-auto max-h-[250px]"}'
                    formControlName="countryId"
                    [attr.aria-invalid]="shouldShowEditFieldError('countryId')"
                  >
                    <option value="">Select a country...</option>
                    @for (item of countries(); track item.id) {
                      <option [value]="item.id">{{ item.name }}</option>
                    }
                  </select>

                  @if (shouldShowEditFieldError('countryId')) {
                    <div class="catalog-field-error">Country is required.</div>
                  }
                </div>

                <div class="grid gap-1.5">
                  <label class="kt-form-label" for="edit-investor-region">
                    Region <span class="catalog-required-marker" aria-hidden="true">*</span>
                  </label>
                  <select
                    id="edit-investor-region"
                    class="kt-select"
                    formControlName="regionId"
                    [attr.aria-invalid]="shouldShowEditFieldError('regionId')"
                  >
                    <option value="">Select region...</option>
                    @for (item of regions(); track item.id) {
                      <option [value]="item.id">{{ item.name }}</option>
                    }
                  </select>

                  @if (shouldShowEditFieldError('regionId')) {
                    <div class="catalog-field-error">Region is required.</div>
                  }
                </div>

                <div class="grid gap-1.5">
                  <label class="kt-form-label" for="edit-investor-group">
                    Investor Group <span class="catalog-required-marker" aria-hidden="true">*</span>
                  </label>
                  <select
                    id="edit-investor-group"
                    class="kt-select"
                    data-kt-select="true"
                    data-kt-select-enable-search="true"
                    data-kt-select-search-placeholder="Search..."
                    data-kt-select-placeholder="Select an investor group..."
                    data-kt-select-config='{"optionsClass":"kt-scrollable overflow-auto max-h-[250px]"}'
                    formControlName="investorGroupId"
                    [attr.aria-invalid]="shouldShowEditFieldError('investorGroupId')"
                  >
                    <option value="">Select investor group...</option>
                    @for (item of investorGroups(); track item.id) {
                      <option [value]="item.id">{{ item.name }}</option>
                    }
                  </select>

                  @if (shouldShowEditFieldError('investorGroupId')) {
                    <div class="catalog-field-error">Investor Group is required.</div>
                  }
                </div>
              </form>

      <section class="mt-6 grid gap-3">
        <div class="flex items-center justify-between gap-2">
          <h4 class="text-sm font-semibold">Attached Documentation</h4>
          <button
            type="button"
            class="kt-btn kt-btn-sm kt-btn-outline"
            [disabled]="isMutatingDocument() || editingInvestorId() === null"
            (click)="openCreateDocumentEditor()"
          >
            <i class="ki-filled ki-plus" aria-hidden="true"></i>
            <span>Add Documentation</span>
          </button>
        </div>
        @if (isDocumentEditorVisible()) {
          <div class="kt-card p-4 border rounded-md grid gap-3">
            <div class="flex items-center justify-between gap-2">
              <h5 class="text-sm font-semibold">{{ documentModalTitle() }}</h5>
              <button type="button" class="kt-btn kt-btn-sm kt-btn-light" [disabled]="isMutatingDocument()" (click)="closeDocumentEditor()">
                Cancel
              </button>
            </div>
            @if (editingDocumentId() === null) {
              <div class="grid gap-1.5">
                <label class="kt-form-label" for="investor-document-files">Files</label>
                <input
                  id="investor-document-files"
                  type="file"
                  class="kt-input"
                  accept=".doc,.msg,.pdf,.xls"
                  multiple
                  [disabled]="isMutatingDocument()"
                  (change)="onDocumentFilesSelected($event)"
                />
                <p class="text-xs text-secondary-foreground">Allowed types: .doc, .msg, .pdf, .xls</p>
              </div>
              @if (documentUploadEntries().length > 0) {
                <div class="grid gap-1">
                  <p class="text-sm font-medium">Selected files</p>
                  <app-document-upload-list [entries]="documentUploadEntries()" />
                </div>
              }
            } @else {
              <div class="grid gap-1.5">
                <label class="kt-form-label" for="investor-document-filename">Filename</label>
                <input
                  id="investor-document-filename"
                  type="text"
                  class="kt-input"
                  [value]="documentForm().filename"
                  (input)="updateDocumentField('filename', $any($event.target).value)"
                />
              </div>
              <div class="grid gap-1.5">
                <label class="kt-form-label" for="investor-document-description">Description</label>
                <input
                  id="investor-document-description"
                  type="text"
                  class="kt-input"
                  [value]="documentForm().description"
                  (input)="updateDocumentField('description', $any($event.target).value)"
                />
              </div>
            }
            @if (documentFormError()) {
              <div class="kt-alert kt-alert-destructive" role="alert">
                <div class="kt-alert-text">{{ documentFormError() }}</div>
              </div>
            }
            <div class="flex justify-end gap-2">
              <button type="button" class="kt-btn kt-btn-light" [disabled]="isMutatingDocument()" (click)="closeDocumentEditor()">Cancel</button>
              <button type="button" class="kt-btn" [disabled]="isMutatingDocument()" (click)="addOrUpdateDocument()">
                <span class="inline-flex items-center gap-2">
                  @if (isMutatingDocument()) {
                    <span class="inline-block h-4 w-4 animate-spin rounded-full border-2 border-current border-r-transparent" aria-hidden="true"></span>
                  }
                  <span>{{ documentModalSubmitLabel() }}</span>
                </span>
              </button>
            </div>
          </div>
        }
        <div class="kt-table-wrapper kt-scrollable">
          <table class="kt-table">
            <thead>
              <tr>
                <th>Description</th>
                <th>Type</th>
                <th>Filename</th>
                <th>Source</th>
                <th class="text-end">Actions</th>
              </tr>
            </thead>
            <tbody>
              @if (documents().length === 0) {
                <tr>
                  <td colspan="5" class="text-center text-secondary-foreground py-4">No documentation found.</td>
                </tr>
              } @else {
                @for (document of documents(); track trackDocument($index, document)) {
                  <tr>
                    <td>
                      <app-document-description-cell
                        [description]="document.description"
                        [documentLabel]="document.filename"
                        [disabled]="isMutatingDocument()"
                        [saving]="describingDocumentId() === document.id"
                        (descriptionChange)="updateDocumentDescription(document, $event)"
                      />
                    </td>
                    <td>{{ document.type || '-' }}</td>
                    <td>
                      <app-document-name-cell
                        [filename]="document.filename"
                        [link]="document.ezShareLink"
                        [disabled]="isMutatingDocument()"
                        [saving]="renamingDocumentId() === document.id"
                        [siblingNames]="documentFilenames()"
                        (rename)="renameDocument(document, $event)"
                      />
                    </td>
                    <td>{{ document.source || '-' }}</td>
                    <td class="text-end">
                      <span class="inline-flex gap-2">
                        <button
                          type="button"
                          class="kt-btn kt-btn-sm kt-btn-icon kt-btn-outline"
                          [disabled]="isMutatingDocument()"
                          (click)="startEditDocumentRow(document)"
                          aria-label="Edit document"
                        >
                          <i class="ki-filled ki-pencil" aria-hidden="true"></i>
                        </button>
                        <button
                          type="button"
                          class="kt-btn kt-btn-sm kt-btn-icon kt-btn-outline"
                          [disabled]="isMutatingDocument()"
                          (click)="requestDeleteDocumentRow(document)"
                          aria-label="Delete document"
                        >
                          @if (deletingDocumentId() === document.id) {
                            <span class="inline-block h-4 w-4 animate-spin rounded-full border-2 border-current border-r-transparent" aria-hidden="true"></span>
                          } @else {
                            <i class="ki-filled ki-trash" aria-hidden="true"></i>
                          }
                        </button>
                      </span>
                    </td>
                  </tr>
                }
              }
            </tbody>
          </table>
        </div>
      </section>

      <section class="mt-6 grid gap-3">
        <div class="flex items-center justify-between gap-2">
          <h4 class="text-sm font-semibold">Notes</h4>
          <button
            type="button"
            class="kt-btn kt-btn-sm kt-btn-outline"
            [disabled]="isMutatingNote() || editingInvestorId() === null"
            (click)="openCreateNoteEditor()"
          >
            <i class="ki-filled ki-plus" aria-hidden="true"></i>
            <span>Add Note</span>
          </button>
        </div>
        @if (isNoteEditorVisible()) {
          <div class="kt-card p-4 border rounded-md grid gap-3">
            <div class="flex items-center justify-between gap-2">
              <h5 class="text-sm font-semibold">{{ noteModalTitle() }}</h5>
              <button type="button" class="kt-btn kt-btn-sm kt-btn-light" [disabled]="isMutatingNote()" (click)="closeNoteEditor()">
                Cancel
              </button>
            </div>
            <div class="grid gap-1.5">
              <label class="kt-form-label" for="investor-note-text">Note</label>
              <textarea
                id="investor-note-text"
                class="kt-textarea"
                rows="4"
                [value]="noteForm().note"
                (input)="updateNoteField($any($event.target).value)"
              ></textarea>
            </div>
            @if (noteFormError()) {
              <div class="kt-alert kt-alert-destructive" role="alert">
                <div class="kt-alert-text">{{ noteFormError() }}</div>
              </div>
            }
            <div class="flex justify-end gap-2">
              <button type="button" class="kt-btn kt-btn-light" [disabled]="isMutatingNote()" (click)="closeNoteEditor()">Cancel</button>
              <button type="button" class="kt-btn" [disabled]="isMutatingNote()" (click)="addOrUpdateNote()">
                <span class="inline-flex items-center gap-2">
                  @if (isMutatingNote()) {
                    <span class="inline-block h-4 w-4 animate-spin rounded-full border-2 border-current border-r-transparent" aria-hidden="true"></span>
                  }
                  <span>{{ noteModalSubmitLabel() }}</span>
                </span>
              </button>
            </div>
          </div>
        }
        <div class="kt-table-wrapper kt-scrollable">
          <table class="kt-table">
            <thead>
              <tr>
                <th>Note</th>
                <th>Modified By</th>
                <th>Date Modified</th>
                <th class="text-end">Actions</th>
              </tr>
            </thead>
            <tbody>
              @if (notes().length === 0) {
                <tr>
                  <td colspan="4" class="text-center text-secondary-foreground py-4">No notes found.</td>
                </tr>
              } @else {
                @for (note of notes(); track trackNote($index, note)) {
                  <tr>
                    <td>{{ note.description || '-' }}</td>
                    <td>{{ note.modifiedBy || '-' }}</td>
                    <td>{{ formatDateTime(note.dateModified) }}</td>
                    <td class="text-end">
                      <span class="inline-flex gap-2">
                        <button
                          type="button"
                          class="kt-btn kt-btn-sm kt-btn-icon kt-btn-outline"
                          [disabled]="isMutatingNote()"
                          (click)="startEditNoteRow(note)"
                          aria-label="Edit note"
                        >
                          <i class="ki-filled ki-pencil" aria-hidden="true"></i>
                        </button>
                        <button
                          type="button"
                          class="kt-btn kt-btn-sm kt-btn-icon kt-btn-outline"
                          [disabled]="isMutatingNote()"
                          (click)="requestDeleteNoteRow(note)"
                          aria-label="Delete note"
                        >
                          @if (deletingNoteId() === note.id) {
                            <span class="inline-block h-4 w-4 animate-spin rounded-full border-2 border-current border-r-transparent" aria-hidden="true"></span>
                          } @else {
                            <i class="ki-filled ki-trash" aria-hidden="true"></i>
                          }
                        </button>
                      </span>
                    </td>
                  </tr>
                }
              }
            </tbody>
          </table>
        </div>
      </section>
    </div>
  </app-catalog-crud-modal>

  <button
    type="button"
    class="hidden"
    aria-hidden="true"
    tabindex="-1"
    data-kt-modal-toggle="#delete_investor_confirm_modal"
  ></button>

  <app-catalog-delete-confirm-modal
    modalId="delete_investor_confirm_modal"
    title="Remove Investor"
    message="Are you sure you want to remove this investor?"
    confirmLabel="Remove Investor"
    [confirming]="deletingInvestorId() !== null"
    (confirm)="confirmDeleteInvestor()"
    (cancel)="cancelDeleteInvestor()"
  ></app-catalog-delete-confirm-modal>

        <!-- Alert area -->
        @if (hasAlert()) {
          <div
            class="kt-alert kt-alert-light"
            [class.kt-alert-success]="alertVariant() === 'success'"
            [class.kt-alert-destructive]="alertVariant() === 'destructive'"
            role="alert"
          >
            <div class="kt-alert-icon">
              <i class="ki-filled ki-information" aria-hidden="true"></i>
            </div>

            <div class="grow">
              <div class="kt-alert-title"><strong>{{ alertTitle() }}</strong></div>

              @if (alertMessage()) {
                <div class="kt-alert-text">{{ alertMessage() }}</div>
              }

              @if (alertVariant() === 'destructive' && alertBlockers().length > 0) {
                <div class="investor-blockers mt-3">
                  <div class="investor-blockers-title">Trade ID / Deal ID blockers:</div>
                  <ul class="investor-blockers-list">
                    @for (blocker of alertBlockers(); track blocker.tradeId + '-' + blocker.dealId) {
                      <li class="investor-blocker-item">
                        <span>Trade ID: <strong>{{ blocker.tradeId }}</strong></span>
                        <span>Deal ID: <strong>{{ blocker.dealId }}</strong></span>
                      </li>
                    }
                  </ul>
                </div>
              }
            </div>

            <div class="kt-alert-toolbar">
              <div class="kt-alert-actions">
                <button
                  type="button"
                  class="kt-alert-close"
                  aria-label="Dismiss alert"
                  (click)="dismissAlert()"
                >
                  <i class="ki-filled ki-cross" aria-hidden="true"></i>
                </button>
              </div>
            </div>
          </div>
        }

        <!-- Loading and fetch error states -->
        @if (isLoading()) {
          <div class="catalog-loading" role="status" aria-live="polite" aria-label="Loading investors">
            <span class="catalog-loading-spinner" aria-hidden="true"></span>
            <span class="catalog-loading-text">Loading...</span>
          </div>
        }

        @if (!isLoading() && errorMessage()) {
          <div class="kt-alert kt-alert-destructive flex items-center justify-between gap-3">
            <span>{{ errorMessage() }}</span>
            <button type="button" class="kt-btn kt-btn-sm kt-btn-light" (click)="loadInvestors()">Retry</button>
          </div>
        }

        <!-- Datatable -->
        @if (!isLoading() && !errorMessage()) {
          <div
            id="kt_investor_datatable"
            class="kt-card-table"
            data-kt-datatable="true"
            data-kt-datatable-page-size="20"
            data-kt-datatable-state-save="true"
            data-kt-datatable-state-namespace="investor-datatable"
            (click)="onTableActionClick($event)"
          >
            <div class="kt-table-wrapper kt-scrollable">
              <table class="kt-table" data-kt-datatable-table="true">
                <thead>
                  <tr>
                    <th scope="col" data-kt-datatable-column="name">
                      <span class="kt-table-col">
                        <span class="kt-table-col-label">Name</span>
                        <span class="kt-table-col-sort"></span>
                      </span>
                    </th>
                    <th scope="col" data-kt-datatable-column="group">
                      <span class="kt-table-col">
                        <span class="kt-table-col-label">Group</span>
                        <span class="kt-table-col-sort"></span>
                      </span>
                    </th>
                    <th scope="col" data-kt-datatable-column="type">
                      <span class="kt-table-col">
                        <span class="kt-table-col-label">Type</span>
                        <span class="kt-table-col-sort"></span>
                      </span>
                    </th>
                    <th scope="col" data-kt-datatable-column="country">
                      <span class="kt-table-col">
                        <span class="kt-table-col-label">Country</span>
                        <span class="kt-table-col-sort"></span>
                      </span>
                    </th>
                    <th scope="col" data-kt-datatable-column="region">
                      <span class="kt-table-col">
                        <span class="kt-table-col-label">Region</span>
                        <span class="kt-table-col-sort"></span>
                      </span>
                    </th>
                    <th
                      scope="col"
                      data-kt-datatable-column="actions"
                      data-kt-datatable-column-sort="false"
                      class="text-end"
                    >
                      Actions
                    </th>
                  </tr>
                </thead>
                <tbody>
                  @if (investors().length === 0) {
                    <tr>
                      <td colspan="6" class="text-center text-secondary-foreground py-6">
                        No investors found.
                      </td>
                    </tr>
                  } @else {
                    @for (item of investors(); track item.id) {
                      <tr>
                        <td>{{ item.name }}</td>
                        <td>{{ item.investorGroupName }}</td>
                        <td>{{ item.investorTypeName }}</td>
                        <td>{{ item.country }}</td>
                        <td>{{ item.region }}</td>
                        <td class="text-end">
                          <span class="inline-flex gap-2.5">
                            <button
                              type="button"
                              class="kt-btn kt-btn-sm kt-btn-icon kt-btn-outline"
                              aria-label="Edit investor"
                              data-action="edit-investor"
                              [attr.data-investor-id]="item.id"
                              [disabled]="deletingInvestorId() !== null || isUpdating()"
                            >
                              <i class="ki-filled ki-pencil" aria-hidden="true"></i>
                            </button>
                            <button
                              type="button"
                              class="kt-btn kt-btn-sm kt-btn-icon kt-btn-outline"
                              aria-label="Remove investor"
                              data-action="delete-investor"
                              [attr.data-investor-id]="item.id"
                              [disabled]="deletingInvestorId() !== null"
                            >
                              <i class="ki-filled ki-trash" aria-hidden="true"></i>
                            </button>
                          </span>
                        </td>
                      </tr>
                    }
                  }
                </tbody>
              </table>
            </div>

            <div class="flex items-center justify-between gap-4 flex-wrap px-5 py-4">
              <div data-kt-datatable-info="true" class="kt-datatable-info text-sm text-secondary-foreground"></div>

              <div class="kt-datatable-length flex items-center gap-3">
                <select data-kt-datatable-size="true" class="kt-select kt-select-sm w-20"></select>
                <div data-kt-datatable-pagination="true" class="kt-datatable-pagination flex items-center gap-2"></div>
              </div>
            </div>
          </div>
        }
</app-catalog-page-card>
